<div id="content" class="allcp-form" ng-controller="StationController" ng-init="all()">
    <div ng-include="'modules/company/menus/order_menu.html'"></div>
    <div class="panel-body">
        <div class="table-responsive" ng-if="data.stations.length > 0">
            <table class="table table-hover tc-checkbox-1 fs13">
                <thead>
                    <tr class="bg-light">
                        <th class="text-center w100">#</th>
                        <th>
                            <a href="#" ng-click="sortType = 'state'; sortReverse = !sortReverse">
                                State
                                <span ng-show="sortType == 'state' && !sortReverse" class="fa fa-caret-down"></span>
                                <span ng-show="sortType == 'state' && sortReverse" class="fa fa-caret-up"></span>
                            </a>
                        </th>
                        <th>
                            <a href="#" ng-click="sortType = 'city'; sortReverse = !sortReverse">
                                City
                                <span ng-show="sortType == 'city' && !sortReverse" class="fa fa-caret-down"></span>
                                <span ng-show="sortType == 'city' && sortReverse" class="fa fa-caret-up"></span>
                            </a>
                        </th>
                        <th>
                            <a href="#" ng-click="sortType = 'code'; sortReverse = !sortReverse">
                                Code
                                <span ng-show="sortType == 'code' && !sortReverse" class="fa fa-caret-down"></span>
                                <span ng-show="sortType == 'code' && sortReverse" class="fa fa-caret-up"></span>
                            </a>
                        </th>
                        <th>
                            <a href="#" ng-click="sortType = 'address'; sortReverse = !sortReverse">
                                Address
                                <span ng-show="sortType == 'address' && !sortReverse" class="fa fa-caret-down"></span>
                                <span ng-show="sortType == 'address' && sortReverse" class="fa fa-caret-up"></span>
                            </a>
                        </th>
                        <th>
                            Zipcode
                        </th>
                        <th>
                            Orders
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="text-left" ng-repeat="item in data.stations | filter: data.term | orderBy:sortType:sortReverse">
                        <td class="text-center">
                            <label class="option block mn">
                                <input type="checkbox" name="deleted[]" ng-checked="deleted.indexOf(item.id) > -1" ng-click="toggleSelection(item.id)">
                                <span class="checkbox mn"></span>
                            </label>
                        </td>
                        <td class="clickable-row" ng-click="openDetail(item)">{{ item.state }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">{{ item.city }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">{{ item.code }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">{{ item.address }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">{{ item.zipcode }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">{{ item.order_count }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="text-center mt50" ng-if="data.stations.length == 0">
            <img src="img/empty_page_orange.svg" alt="" width="400px">
            <br>
            <h3 style="font-size: 48px;font-weight: 800;">Station not yet</h3>
            <p style="text-transform: uppercase;font-weight: 600;color: #000;">Station not found</p>
        </div>
    </div>
    <div ng-include="'modules/company/stations/modal.html'"></div>
    <div ng-include="'modules/company/settings/partials/delete.html'"></div>
</div>